















































































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import EditorWithFile from "@/components/EditorWithFile.vue";
import api from "@/getinfo-api/";
import moment from "moment";
import userList, { UsersListParams } from "@/getinfo-api/users";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { getCurrentCompanyId, isRoot } from "@/plugins/roles";
import { getCurrentUserId } from "@/plugins/roles";
import { BBBWebinarCreate as IBBBWebinarCreate } from "@/api/models/bbbwebinar-create";
import { BBBWebinarEdit as IBBBWebinarEdit } from "@/api/models/bbbwebinar-edit";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { User as IUser } from "@/api/models/user";
import { Company as ICompany } from "@/api/models/company";
import { UsersList as IUsersList } from "@/api/models/users-list";
import { BBBWebinar as IBBBWebinar } from "@/api/models/bbbwebinar";
import { ThirdPartyWebinarCreate as IThirdPartyWebinarCreate } from "@/api/models/third-party-webinar-create";
import { ThirdPartyWebinar as IThirdPartyWebinar } from "@/api/models/third-party-webinar";
import { ThirdPartyWebinarEdit as IThirdPartyWebinarEdit } from "@/api/models/third-party-webinar-edit";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { CategoryList as ICategoryList } from "@/api/models/category-list";
import { uniqBy, debounce, remove } from "lodash";
import SelectEntity from "@/components/form/SelectEntity.vue";
import { Employee as IEmployee } from "@/api/models/employee";
import categories, { CategoriesListParams } from "@/getinfo-api/categories";
import { Webinar as IWebinar, WebinarStatusEnum } from "@/api/models/webinar";
import Modal from "@/components/form/Modal.vue";
import { webinarRoomModule } from "@/plugins/modules-detect";
import CustomButton from "@/components/form/CustomButton.vue";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import SearchUser from "@/components/user/SearchUser.vue";
import { LearningMaterialLocales } from "@/plugins/custom-interface";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";

@Component({
  components: {
    CustomDatepicker,
    SearchUser,
    CSingleSelect,
    CField,
    CustomButton,
    Modal,
    EditorWithFile,
    SelectEntity
  }
})
export default class WebinarForm extends Vue {
  @Prop() bbbWebinar?: IBBBWebinar;
  @Prop() thirdPartyWebinar?: IThirdPartyWebinar;
  @Prop() webinar!: IWebinar;
  title!: string;
  body!: string | undefined;
  startedAt!: Date;
  finishedAt!: Date;
  selectedSource: string = "ThirdParty";
  timeStartedAt!: string | number;
  timeFinishedAt!: string;
  companyId!: string;
  price: number = 0;
  ownerId!: string;
  viewersLimit: number = 0;
  enabled: boolean | undefined;
  employeesList!: Array<IEmployee>;
  currentUserId!: string;
  record: boolean = true;
  lockSettingsDisableCam: boolean = false;
  lockSettingsDisableMic: boolean = false;
  lockSettingsDisablePublicChat: boolean = false;
  searchUser!: string;
  searchUsersList: Array<IUser | any> = [];
  usersWithAccessWebinar: Array<IUser> | undefined = [];
  thirdPartyUrl!: string;
  currentUserIsRoot: boolean = false;
  companiesList!: Array<ICompany>;
  categoryId!: string;
  categoryList!: any;
  limit: number = 30;
  offset: number = 0;
  viewersCount: number | undefined = 0;
  showSpinner: boolean = false;
  minDateForCreateWebinar: Date = new Date();
  isSavingProcess: boolean = false;
  locale: string = "";

  data() {
    return {
      title: undefined,
      body: undefined,
      startedAt: undefined,
      finishedAt: undefined,
      timeStartedAt: undefined,
      timeFinishedAt: undefined,
      companyId: undefined,
      ownerId: undefined,
      employeesList: undefined,
      currentUserId: undefined,
      searchUser: undefined,
      thirdPartyUrl: undefined,
      enabled: true,
      visibleSpinner: false,
      categoryId: undefined,
      companiesList: [],
      categoryList: undefined
    };
  }

  get addedUsersIds() {
    return this.usersWithAccessWebinar?.map(el => el.id);
  }

  @Watch("startedAt")
  setFinishDate() {
    if (this.startedAt) {
      if (!this.webinar) {
        this.finishedAt = this.startedAt;
      }
    }
  }

  @Watch("selectedCompany")
  updateSelectedCompany() {
    if (!this.bbbWebinar && !this.thirdPartyWebinar) {
      this.companyId = this.selectedCompany.id;
      this.companiesList.push(this.selectedCompany);
    }
    if (this.companyId) {
      this.getEmployee();
    }
  }

  get currentCompanyId(): string {
    return getCurrentCompanyId();
  }

  get locales() {
    return LearningMaterialLocales();
  }

  get webinarRoomBundle() {
    return webinarRoomModule();
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get selectedCompany() {
    return this.$store.getters.selectedCompany;
  }

  get userId() {
    return getCurrentUserId();
  }

  getEmployee() {
    let params: EmployeeListParams = {
      id: this.companyId,
      roles: ["content_manager"],
      limit: 200
    };

    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.employeesList = res.data.employees;
      if (this.root || this.companyOwner) {
        if (!this.bbbWebinar && !this.webinar && !this.thirdPartyWebinar) {
          this.ownerId = res.data.employees[0].user.id;
        }
      } else {
        if (!this.bbbWebinar && !this.webinar && !this.thirdPartyWebinar) {
          this.ownerId = this.userId;
        }
      }
    });
  }

  addUserToWebinar(user: IUser) {
    if (!this.thirdPartyWebinar && !this.bbbWebinar) {
      if (this.viewersLimit) {
        if (
          this.usersWithAccessWebinar &&
          this.usersWithAccessWebinar.length < this.viewersLimit
        ) {
          this.usersWithAccessWebinar.push(user);
          this.usersWithAccessWebinar = uniqBy(
            this.usersWithAccessWebinar,
            "id"
          );
          this.searchUsersList = [];
          this.searchUser = "";
        } else {
          this.$bvToast.toast(
            `${this.$tc(
              this.$translate.MaximumNumberOfUsersWithAccessToTheWebinar
            )}: ${this.viewersLimit}`,
            {
              variant: "danger",
              title: `${this.$tc(this.$translate.Error)}`
            }
          );
        }
      } else {
        this.$bvToast.toast(
          `${this.$tc(
            this.$translate
              .PleaseSpecifyTheMaximumNumberOfUsersWhoHaveAccessToTheWebinar
          )}`,
          {
            variant: "danger",
            title: `${this.$tc(this.$translate.Error)}`
          }
        );
      }
    } else {
      api.WebinarApi.addViewers(this.$route.params.webinarId, [user.id])
        .then(() => {
          this.offset = 0;
          this.viewersCount = 0;
          this.usersWithAccessWebinar = [];
          this.getWebinarViewers();
          this.searchUser = "";
        })
        .catch(
          (error: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
            if (error.response) {
              this.$bvToast.toast(`${error.response.data.message}`, {
                variant: "danger",
                title: this.$tc(this.$translate.Error)
              });
            }
          }
        );
    }
    this.searchUsersList = [];
    this.searchUser = "";
  }

  @Watch("searchUser")
  searchUserWithDebounce = debounce(function() {
    //@ts-ignore
    let _this = this;
    if (_this.searchUser.length > 2) {
      _this.searchUsersList = [];
      _this.allSearchUsersResult = [];
      let allParams = [];
      let firstNameParam: UsersListParams = {
        firstName: _this.searchUser
      };
      let lastNameParam: UsersListParams = {
        lastName: _this.searchUser
      };
      let emailParam: UsersListParams = {
        email: _this.searchUser
      };
      allParams.push(firstNameParam, lastNameParam, emailParam);
      allParams.forEach(element => {
        userList(element).then((res: { data: IUsersList }) => {
          if (res.data.users && res.data.users.length > 0) {
            res.data.users.forEach(item => {
              _this.allSearchUsersResult.push(item);
            });
            _this.searchUsersList = uniqBy(_this.allSearchUsersResult, "email");
          }
        });
      });
    }
  }, 300);

  async createWebinar() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    if (this.$store.getters.GET_FORM_IS_INVALID) {
      return;
    }
    if (this.startedAt && this.finishedAt) {
      let hourStarted = moment(this.timeStartedAt, "HH:mm:ss").hour();
      let minuteStarted = moment(this.timeStartedAt, "HH:mm:ss").minute();
      let hourFinishedAt = moment(this.timeFinishedAt, "HH:mm:ss").hour();
      let minuteFinishedAt = moment(this.timeFinishedAt, "HH:mm:ss").minute();
      this.startedAt.setHours(hourStarted);
      this.startedAt.setMinutes(minuteStarted);
      this.finishedAt.setHours(hourFinishedAt);
      this.finishedAt.setMinutes(minuteFinishedAt);
    }

    if (this.selectedSource === "BBB") {
      this.isSavingProcess = true;
      let createWebinarInterface: IBBBWebinarCreate = {
        record: this.record,
        webinar: {
          companyId: this.companyId,
          title: this.title,
          body: this.body,
          ownerId: this.ownerId,
          viewersLimit: this.viewersLimit + 1,
          price: this.$converter.setPrice(this.price),
          enabled: this.enabled,
          startedAt: this.startedAt,
          categoryId: this.categoryId,
          finishedAt: this.finishedAt,
          locale: this.locale ?? ""
        },
        lockSettingsDisableCam: this.lockSettingsDisableCam,
        lockSettingsDisableMic: this.lockSettingsDisableMic,
        lockSettingsDisablePublicChat: this.lockSettingsDisablePublicChat
      };
      api.BBBWebinarApi.create(createWebinarInterface)
        .then((res: { data: IBBBWebinar }) => {
          let usersAccess = [];
          usersAccess.push(this.currentUserId);
          if (this.usersWithAccessWebinar) {
            this.usersWithAccessWebinar.forEach(element => {
              usersAccess.push(element.id);
            });
          }
          api.WebinarApi.addViewers(res.data.webinar.id, usersAccess)
            .then(() => {
              this.$bvToast.toast(
                `${this.$tc(this.$translate.Webinar)} ${
                  res.data.webinar.title
                }`,
                {
                  variant: "success",
                  title: `${this.$tc(this.$translate.Success)}`
                }
              );
              this.$router.push({ name: "webinars" });
            })
            .catch(
              (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
                this.$store.dispatch("errorException", {
                  vm: this,
                  error: err.response
                });
              }
            );
        })
        .catch(
          (error: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
            if (error.response) {
              this.$bvToast.toast(`${error.response.data.message}`, {
                variant: "danger",
                title: this.$tc(this.$translate.Error)
              });
            }
          }
        )
        .finally(() => {
          this.isSavingProcess = false;
        });
    } else {
      this.isSavingProcess = true;
      let createWebinarInterface: IThirdPartyWebinarCreate = {
        url: this.thirdPartyUrl,
        webinar: {
          companyId: this.companyId,
          title: this.title,
          body: this.body,
          ownerId: this.ownerId,
          viewersLimit: this.viewersLimit + 1,
          price: this.$converter.setPrice(this.price),
          enabled: this.enabled,
          categoryId: this.categoryId,
          startedAt: this.startedAt,
          finishedAt: this.finishedAt,
          locale: this.locale ?? ""
        }
      };
      api.ThirdPartyWebinarApi.create(createWebinarInterface)
        .then((res: { data: IThirdPartyWebinar }) => {
          this.$bvToast.toast(
            `${this.$tc(this.$translate.Webinar)} ${res.data.webinar.title}`,
            {
              variant: "success",
              title: `${this.$tc(this.$translate.Success)}`
            }
          );
          let usersAccess = [];
          usersAccess.push(this.currentUserId);
          if (this.usersWithAccessWebinar) {
            this.usersWithAccessWebinar.forEach(element => {
              usersAccess.push(element.id);
            });
          }
          api.WebinarApi.addViewers(res.data.webinar.id, usersAccess).then(
            () => {
              this.$bvToast.toast(`${this.$tc(this.$translate.Successful)}`, {
                variant: "success",
                title: `${this.$tc(this.$translate.Success)}`
              });
              this.$router.push({ name: "webinars" });
            }
          );
        })
        .catch(
          (error: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
            if (error.response) {
              this.$bvToast.toast(`${error.response.data.message}`, {
                variant: "danger",
                title: this.$tc(this.$translate.Error)
              });
            }
          }
        )
        .finally(() => {
          this.isSavingProcess = false;
        });
    }
  }

  saveWebinar() {
    if (!this.bbbWebinar && !this.thirdPartyWebinar) {
      this.createWebinar();
    } else {
      this.editWebinar();
    }
  }

  editWebinar() {
    if (this.startedAt && this.finishedAt) {
      let hourStarted = moment(this.timeStartedAt, "HH:mm:ss").hour();
      let minuteStarted = moment(this.timeStartedAt, "HH:mm:ss").minute();
      let hourFinishedAt = moment(this.timeFinishedAt, "HH:mm:ss").hour();
      let minuteFinishedAt = moment(this.timeFinishedAt, "HH:mm:ss").minute();
      this.startedAt.setHours(hourStarted);
      this.startedAt.setMinutes(minuteStarted);
      this.finishedAt.setHours(hourFinishedAt);
      this.finishedAt.setMinutes(minuteFinishedAt);
    }
    //BBBWebinar in @Prop
    if (this.bbbWebinar) {
      if (this.selectedSource === "BBB") {
        let editBBBWebinarInterface: IBBBWebinarEdit = {
          webinar: {
            title: this.title,
            body: this.body,
            ownerId: this.ownerId,
            viewersLimit: this.viewersLimit + 1,
            price: this.$converter.setPrice(this.price),
            enabled: this.enabled,
            startedAt: this.startedAt,
            categoryId: this.categoryId,
            finishedAt: this.finishedAt,
            locale: this.locale ?? ""
          },
          record: this.record,
          lockSettingsDisableCam: this.lockSettingsDisableCam,
          lockSettingsDisableMic: this.lockSettingsDisableMic,
          lockSettingsDisablePublicChat: this.lockSettingsDisablePublicChat
        };
        this.isSavingProcess = true;
        api.BBBWebinarApi.edit(
          this.bbbWebinar.webinar.id,
          editBBBWebinarInterface
        )
          .then(() => {
            this.$router.push({ name: "webinars" });
          })
          .catch(
            (error: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              if (error.response) {
                this.$bvToast.toast(`${error.response.data.message}`, {
                  variant: "danger",
                  title: `${this.$tc(this.$translate.Error)}`
                });
              }
            }
          )
          .finally(() => {
            this.isSavingProcess = false;
          });
      }
      if (this.selectedSource === "ThirdParty") {
        api.WebinarApi.v1WebinarIdDelete(this.bbbWebinar.webinar.id);
        this.createWebinar();
      }
    }

    //ThirdPartyWebinar in @Prop
    if (this.thirdPartyWebinar) {
      if (this.selectedSource === "ThirdParty") {
        let editThirdPartyWebinarInterface: IThirdPartyWebinarEdit = {
          url: this.thirdPartyUrl,
          webinar: {
            title: this.title,
            body: this.body,
            ownerId: this.ownerId,
            viewersLimit: this.viewersLimit + 1,
            price: this.$converter.setPrice(this.price),
            enabled: this.enabled,
            categoryId: this.categoryId,
            startedAt: this.startedAt,
            finishedAt: this.finishedAt,
            locale: this.locale ?? ""
          }
        };
        api.ThirdPartyWebinarApi.edit(
          this.thirdPartyWebinar.webinar.id,
          editThirdPartyWebinarInterface
        )
          .then(() => {
            this.$router.push({ name: "webinars" });
          })
          .catch(
            (error: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              if (error.response) {
                this.$bvToast.toast(`${error.response.data.message}`, {
                  variant: "danger",
                  title: this.$tc(this.$translate.Error)
                });
              }
            }
          );
      }
      if (this.selectedSource === "BBB") {
        api.WebinarApi.v1WebinarIdDelete(this.thirdPartyWebinar.webinar.id);
        this.createWebinar();
      }
    }
  }

  getInfoEditWebinar() {
    if (this.bbbWebinar && this.bbbWebinar.webinar.viewersLimit) {
      this.companyId = this.bbbWebinar.webinar.companyId;
      this.title = this.bbbWebinar.webinar.title;
      this.body = this.bbbWebinar.webinar.body;
      this.ownerId = this.bbbWebinar.webinar.ownerId;
      this.viewersLimit = this.bbbWebinar.webinar.viewersLimit - 1;
      this.price = this.$converter.getPrice(this.bbbWebinar.webinar.price);
      this.enabled = this.bbbWebinar.webinar.enabled;
      this.startedAt = this.bbbWebinar.webinar.startedAt;
      this.finishedAt = this.webinar.finishedAt;
      this.record = this.bbbWebinar.record;
      this.lockSettingsDisableCam = this.bbbWebinar.lockSettingsDisableCam;
      this.lockSettingsDisableMic = this.bbbWebinar.lockSettingsDisableMic;
      this.lockSettingsDisablePublicChat = this.bbbWebinar.lockSettingsDisablePublicChat;
      this.selectedSource = "BBB";
      this.categoryId = this.bbbWebinar.webinar.category?.id ?? "";
      this.locale = this.bbbWebinar.webinar?.locale ?? "";
      this.formatDateToEdit();
      this.getEmployee();

      api.CompanyApi.get(this.companyId)
        .then((res: { data: ICompany }) => {
          this.companiesList.push(res.data);
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
    if (this.thirdPartyWebinar && this.thirdPartyWebinar.webinar.viewersLimit) {
      this.companyId = this.thirdPartyWebinar.webinar.companyId;
      this.title = this.thirdPartyWebinar.webinar.title;
      this.body = this.thirdPartyWebinar.webinar.body;
      this.ownerId = this.thirdPartyWebinar.webinar.ownerId;
      this.viewersLimit = this.thirdPartyWebinar.webinar.viewersLimit - 1;
      this.price = this.$converter.getPrice(
        this.thirdPartyWebinar.webinar.price
      );
      this.enabled = this.thirdPartyWebinar.webinar.enabled;
      this.startedAt = this.thirdPartyWebinar.webinar.startedAt;
      this.finishedAt = this.thirdPartyWebinar.webinar.finishedAt;
      this.selectedSource = "ThirdParty";
      this.thirdPartyUrl = this.thirdPartyWebinar.url;
      this.categoryId = this.thirdPartyWebinar.webinar.category?.id ?? "";
      this.locale = this.thirdPartyWebinar.webinar.locale ?? "";
      this.formatDateToEdit();
      this.getEmployee();

      api.CompanyApi.get(this.companyId)
        .then((res: { data: ICompany }) => {
          this.companiesList.push(res.data);
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  @Watch("viewersLimit")
  viewersLimitIsNull() {
    if (this.viewersLimit < 0) {
      this.viewersLimit = 0;
    }
  }

  get finishedStatus() {
    return this.webinar?.status === WebinarStatusEnum.Finished;
  }

  deleteWebinar() {
    api.WebinarApi.v1WebinarIdDelete(this.$route.params.webinarId)
      .then(() => {
        this.$router.push({ name: "webinars" });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  formatDateToEdit() {
    this.timeStartedAt = moment(this.startedAt).format("HH:mm:ss");
    this.timeFinishedAt = moment(this.finishedAt).format("HH:mm:ss");
    this.startedAt = moment(this.startedAt, "YYYY-MM-DDTHH:mm:ssZ").toDate();
    this.finishedAt = moment(this.finishedAt, "YYYY-MM-DDTHH:mm:ssZ").toDate();
  }

  deleteViewer(user: IUser) {
    if (!this.bbbWebinar && !this.thirdPartyWebinar) {
      if (this.usersWithAccessWebinar) {
        this.usersWithAccessWebinar = remove(
          this.usersWithAccessWebinar,
          function(item) {
            return item.id !== user.id;
          }
        );
      }
    } else {
      api.WebinarApi.removeViewers(this.$route.params.webinarId, [user.id])
        .then(() => {
          this.usersWithAccessWebinar = [];
          this.offset = 0;
          this.viewersCount = 0;
          this.getWebinarViewers();
        })
        .catch(
          (error: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
            if (error.response) {
              this.$bvToast.toast(`${error.response.data.message}`, {
                variant: "danger",
                title: `${this.$tc(this.$translate.Error)}`
              });
            }
          }
        );
    }
  }

  get screenWidth() {
    return window.innerWidth;
  }

  showMore() {
    this.offset += this.limit;
    this.getWebinarViewers(this.offset);
  }

  getWebinarViewers(offset: number = 0) {
    if (this.bbbWebinar || this.thirdPartyWebinar) {
      this.showSpinner = true;
      api.WebinarApi.getViewers(
        this.$route.params.webinarId,
        offset,
        this.limit
      )
        .then((res: { data: IUsersList }) => {
          this.viewersCount = res.data.count;
          res.data.users?.forEach((user: IUser) => {
            //@ts-ignore
            this.usersWithAccessWebinar.push(user);
          });
        })
        .finally(() => {
          this.showSpinner = false;
        });
    }
  }

  getAllCategory() {
    let params: CategoriesListParams = {
      companyId: this.currentCompanyId,
      limit: 600
    };
    categories(params)
      .then((res: { data: ICategoryList }) => {
        this.categoryList = res.data.items;
        if (!this.webinar) {
          this.categoryId = this.categoryList[0].id;
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  created() {
    this.currentUserId = getCurrentUserId();
    this.currentUserIsRoot = isRoot();
    this.getInfoEditWebinar();
    this.getWebinarViewers();
    this.getAllCategory();
    this.updateSelectedCompany();
  }
}
